<template>
    <div>
        <login-header />
        <div class="login">
            <div class="logo-icon">
                <div class="mr-re"></div>
                <div class="mr-bil"></div>
                <div class="mr-ly"></div>
            </div>
            <span class="text-center" v-if="!isLoading">
                <v-inline-notifications class="stack-m" title="Account Activation" type="positive" :permanent="true">
                    <span slot="content">Your account was activated successfully.</span>
                </v-inline-notifications>
            </span>
            <span class="text-center" v-else>
                <v-inline-notifications class="stack-m" title="Account Activation" type="warning" :permanent="true">
                    <span slot="content">Please wait while we activate your account...</span>
                </v-inline-notifications>
            </span>
            <div class="tile tile-secondary stack-l">
                <div class="tile-content">
                    <router-link :fluid="true" :to="{name: 'login'}">Go back to Log In</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginHeader from '@/modules/guest/login-header';
    import vInlineNotifications from '@/components/v-inline-notifications';

    export default {
        name: 'activate',
        components: {
            LoginHeader, vInlineNotifications,
        },
        props: {
            token: {
                type: String,
            },
        },
        data() {
            return {
                isLoading: false,
            };
        },
        methods: {
            async activateMerchant() {
                this.isLoading = true;
                try {
                    const {token} = this;
                    await this.$api(({account}) => account.activate({token}));
                } catch (error) {
                    this.$toast.fromError(error, 'Unable to activate your account. Please contact support.');
                    this.$redirectOnError(error, {name: 'login'});
                } finally {
                    this.isLoading = false;
                }
            },
        },
        created() {
            this.activateMerchant();
        },
    };
</script>
